import React from 'react';
import { WeatherHint } from './WeatherHint';

const RealmGlyph = ({ realmId, color, locked }) => {
  const stroke = locked ? '#D5CFC6' : color;
  const glyphs = {
    1: (
      <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke={stroke} strokeWidth="1.5">
        <path d="M2 13c2-2 4-2 6 0s4 2 6 0 4-2 6 0" />
        <path d="M2 18c2-2 4-2 6 0s4 2 6 0 4-2 6 0" />
        <circle cx="17" cy="6" r="3" />
      </svg>
    ),
    2: (
      <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke={stroke} strokeWidth="1.5">
        <path d="M12 21V11" />
        <path d="M12 11c0-4 3-6 7-6 0 4-3 6-7 6z" />
        <path d="M12 15c0-3-2.5-5-6-5 0 3 2.5 5 6 5z" />
      </svg>
    ),
    3: (
      <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke={stroke} strokeWidth="1.5">
        <path d="M4 20c0-8 3.5-14 8-14s8 6 8 14" />
        <circle cx="12" cy="13" r="2.5" />
      </svg>
    ),
    4: (
      <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke={stroke} strokeWidth="1.5">
        <path d="M12 4c2.5 3 4.5 5.5 4.5 8.5a4.5 4.5 0 11-9 0C7.5 9.5 9.5 7 12 4z" />
        <path d="M4 21h16" />
      </svg>
    ),
    5: (
      <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke={stroke} strokeWidth="1.5">
        <path d="M3 16h18" />
        <path d="M12 12a4 4 0 014 4H8a4 4 0 014-4z" />
        <path d="M12 5v2M6 8l1.5 1.5M18 8l-1.5 1.5" />
      </svg>
    ),
  };
  return glyphs[realmId] || null;
};

export const RealmNode = ({ realmId, name, subtitle, color, locked, current, entryCount, weather, worldElements, align, onTap }) => (
  <button
    onClick={onTap}
    disabled={locked}
    className={`w-full max-w-[280px] p-5 rounded-2xl text-left transition-all duration-200 ${locked ? 'cursor-default' : 'active:scale-[0.97] hover:translate-y-[-2px]'} ${align === 'right' ? 'ml-auto' : 'mr-auto'}`}
    style={{
      background: locked ? '#FAF7F3' : '#F7F1EE',
      border: current ? `1px solid ${color}55` : '1px solid transparent',
      boxShadow: current ? `0 0 24px ${color}22` : 'none',
      opacity: locked ? 0.5 : 1,
    }}
    data-testid={`realm-node-${realmId}`}
  >
    <div className="flex items-center gap-4">
      <div
        className="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0"
        style={{ background: locked ? '#F7F1EE' : `${color}1f` }}
      >
        <RealmGlyph realmId={realmId} color={color} locked={locked} />
      </div>
      <div>
        <h3 className="text-sm tracking-[0.08em] mb-0.5" style={{ fontFamily: 'Jost, sans-serif', color: locked ? '#8A8798' : color }}>
          {name}
        </h3>
        <p className="text-xs" style={{ fontFamily: 'Jost, sans-serif', color: locked ? '#D5CFC6' : 'rgba(232,180,184,0.65)' }}>
          {locked ? 'Not yet open — it will wait for you' : subtitle}
        </p>
        {!locked && (entryCount > 0 || weather || worldElements?.length > 0) && (
          <div className="flex items-center gap-3 mt-1.5 flex-wrap">
            {entryCount > 0 && (
              <span className="text-[11px]" style={{ fontFamily: 'Jost, sans-serif', color: '#A3A0AE' }}>
                {entryCount} {entryCount === 1 ? 'reflection' : 'reflections'}
              </span>
            )}
            {weather && <WeatherHint tone={weather} />}
            {worldElements?.length > 0 && (
              <span className="flex items-center gap-1" data-testid={`world-detail-${realmId}`}>
                {worldElements.slice(0, 8).map((el, i) => (
                  <span key={el} className="w-1 h-1 rounded-full" style={{ background: color, opacity: 0.5 + i * 0.05, boxShadow: `0 0 4px ${color}` }} />
                ))}
              </span>
            )}
          </div>
        )}
      </div>
    </div>
  </button>
);
